<template>
    <div>
        <rkm-row v-if="evoluoes.length > 0">
            <rkm-col id="evolucao-medica">
                <rkm-form-incremental-textarea
                    :items="evoluoes"
                    :readonly="readonly"
                    :validations="validations.evolucao"
                    label="Evolução Médica"
                    v-model="data.model.evolucao"
                >
                    <template v-slot:row="{ item }">
                        <rkm-row>
                            <rkm-col cols="4">
                                <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                <div>{{ item.lotacao.profissional.nome }}</div>
                                <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                <div>{{ item.dataHora }}</div>
                            </rkm-col>

                            <rkm-col>
                                {{ item.descricao }}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-form-incremental-textarea>
            </rkm-col>
        </rkm-row>

        <div v-if="data.form.tipoAtendimentoId === enums.tipoAtendimento.ESTRUTURADO">
            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                        :readonly="readonly"
                        :items="data.form.atendimentoMedico.queixasPrincipalDuracao"
                        :validations="validations.atendimento.queixaPrincipalDuracao"
                        label="Queixa Principal e Duração"
                        v-model="data.model.queixaPrincipalDuracao"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                    :readonly="readonly"
                        :items="data.form.atendimentoMedico.historias"
                        :validations="validations.atendimento.historia"
                        label="História do Paciente"
                        v-model="data.model.historia"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                    :readonly="readonly"
                        :items="data.form.atendimentoMedico.examesFisico"
                        :validations="validations.atendimento.exameFisico"
                        label="Exame Físico"
                        v-model="data.model.exameFisico"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                    :readonly="readonly"
                        :items="data.form.atendimentoMedico.diagnosticos"
                        :validations="validations.atendimento.diagnostico"
                        label="Diagnóstico"
                        v-model="data.model.diagnostico"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                    :readonly="readonly"
                        :items="data.form.atendimentoMedico.condutas"
                        :validations="validations.atendimento.conduta"
                        label="Conduta"
                        v-model="data.model.conduta"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>
        </div>

        <div v-else>
            <rkm-row>
                <rkm-col>
                    <rkm-form-incremental-textarea
                    :readonly="readonly"
                        :items="data.form.atendimentoMedico.atendimentosGerais"
                        :validations="validations.atendimento.atendimentoGeral"
                        label="Anamnese"
                        v-model="data.model.atendimentoGeral"
                    >
                        <template v-slot:row="{ item }">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <div>Setor: {{ item.centroCusto.setor.nome }}</div>
                                    <div>{{ item.lotacao.profissional.nome }}</div>
                                    <div>Class. Risco: {{ item.classificacaoRisco.nome }}</div>
                                    <div>{{ item.dataHora }}</div>
                                </rkm-col>

                                <rkm-col>
                                    {{ item.descricao }}
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </rkm-form-incremental-textarea>
                </rkm-col>
            </rkm-row>
        </div>
    </div>
</template>

<script>
// Components.
import RkmFormIncrementalTextarea from '@/components/pronto-atendimento/components/base/FormIncrementalTextarea'

// Enums.
import tipoAtendimento from '@/enums/pronto-atendimento/parametrizacao/tipoAtendimento'

export default {
    components: { RkmFormIncrementalTextarea },
    computed: {
        evoluoes() {

            return Array.isArray(this.data.form.evolucao)
                ? this.data.form.evolucao
                : this.data.form.atendimentoMedico.evolucoes
        },
        required() {
            return (
                !this.data.form.reavaliacao &&
                !this.data.model.queixaPrincipalDuracao &&
                !this.data.model.historia &&
                !this.data.model.exameFisico &&
                !this.data.model.diagnostico &&
                !this.data.model.conduta
            )
        },
        validations() {
            return {
                evolucao: {
                    required: this.data.form.reavaliacao,
                    max: 500,
                },
                atendimento: {
                    queixaPrincipalDuracao: {
                        required: this.required,
                        max: 300,
                    },
                    historia: {
                        required: this.required,
                        max: 300,
                    },
                    exameFisico: {
                        required: this.required,
                        max: 300,
                    },
                    diagnostico: {
                        required: this.required,
                        max: 300,
                    },
                    conduta: {
                        required: this.required,
                        max: 300,
                    },
                    atendimentoGeral: {
                        required: !this.data.form.reavaliacao && this.data.form.tipoAtendimentoId === this.enums.tipoAtendimento.SIMPLES,
                        max: 300,
                    },
                    observacoesEnfermagem: { max: 500 },
                },
            }
        },
    },
    data: () => ({
        enums: { tipoAtendimento ,}
    }),
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean }
    },
}
</script>